import { render, staticRenderFns } from "./TicketMessageSendConfig.vue?vue&type=template&id=9a82621c&scoped=true"
import script from "./TicketMessageSendConfig.vue?vue&type=script&lang=js"
export * from "./TicketMessageSendConfig.vue?vue&type=script&lang=js"
import style0 from "./TicketMessageSendConfig.vue?vue&type=style&index=0&id=9a82621c&prod&lang=less"
import style1 from "./TicketMessageSendConfig.vue?vue&type=style&index=1&id=9a82621c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a82621c",
  null
  
)

export default component.exports